"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = __importDefault(require("classnames"));
var Tooltip_1 = __importDefault(require("acl-ui/components/Tooltip"));
var Popover_1 = __importDefault(require("acl-ui/components/Popover"));
var l10n_1 = require("@paprika/l10n");
var SearchInput_1 = __importDefault(require("../SearchInput/SearchInput"));
require("./ResizableLeftPanel.scss");
var MIN_WIDTH = 40;
var SNAP_WIDTH = 250;
var SNAP_PADDING = 80;
var ResizableLeftPanel = /** @class */ (function (_super) {
    __extends(ResizableLeftPanel, _super);
    function ResizableLeftPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.handleMouseDown = function (e) {
            e.preventDefault();
            var preDragWidth;
            if (_this.props.width > SNAP_WIDTH) {
                preDragWidth = _this.props.width;
            }
            else if (_this.props.backupWidth > SNAP_WIDTH) {
                preDragWidth = _this.props.backupWidth;
            }
            else {
                preDragWidth = SNAP_WIDTH;
            }
            _this.setState({
                dragging: true,
                preDragWidth: preDragWidth,
            });
        };
        _this.handleMouseUp = function () {
            _this.setState({ dragging: false });
        };
        _this.handleMouseMove = function (e) {
            if (_this.state.dragging) {
                if (e.clientX > SNAP_WIDTH) {
                    _this.resizeHandler(e.clientX, _this.props.backupWidth);
                }
                else if (e.clientX < SNAP_WIDTH - SNAP_PADDING) {
                    _this.resizeHandler(MIN_WIDTH, _this.state.preDragWidth);
                }
            }
        };
        _this.collapseHandler = function () {
            if (_this.isCollapsed()) {
                _this.resizeHandler(_this.props.backupWidth, _this.props.backupWidth);
            }
            else {
                _this.resizeHandler(MIN_WIDTH, _this.props.width);
            }
            if (_this.props.collapseToggleCallback) {
                _this.props.collapseToggleCallback(!_this.isCollapsed());
            }
            if (_this.props.afterResizeCallback) {
                setTimeout(function () {
                    _this.props.afterResizeCallback();
                }, 300);
            }
        };
        _this.panelWidth = function () { return (_this.props.width >= MIN_WIDTH ? _this.props.width : MIN_WIDTH); };
        _this.isCollapsed = function () { return _this.props.width <= MIN_WIDTH; };
        _this.renderSearch = function () {
            if (_this.props.onSearchChange && !_this.isCollapsed()) {
                return (react_1.default.createElement("div", { className: "results-panel__search" },
                    react_1.default.createElement(Popover_1.default, { show: _this.props.showSearchPopover, align: "right", content: _this.props.i18n.t('left_navigation.small_search') },
                        react_1.default.createElement(SearchInput_1.default, { onChange: _this.props.onSearchChange, value: _this.props.searchValue, placeholder: _this.props.i18n.t('left_navigation.filter_search') }))));
            }
            return null;
        };
        _this.renderArchivedProjectsLink = function () {
            return (react_1.default.createElement("a", { href: _this.props.resultsUrl + "/archived_projects", "aria-label": _this.props.i18n.t('left_navigation.collection_archive') },
                react_1.default.createElement("i", { className: "acl-i-archive" }),
                react_1.default.createElement("span", { className: "results-panel__footer__text" }, _this.props.i18n.t('left_navigation.collection_archive'))));
        };
        _this.renderActivitiesLink = function () {
            if (!_this.props.canViewSettings) {
                return null;
            }
            return (react_1.default.createElement("a", { href: _this.props.resultsUrl + "/activities", "aria-label": _this.props.i18n.t('left_navigation.activities.title') },
                react_1.default.createElement("i", { className: "acl-i-history" }),
                react_1.default.createElement("span", { className: "results-panel__footer__text" }, _this.props.i18n.t('left_navigation.activities.title'))));
        };
        _this.renderSettingsLink = function () {
            if (!_this.props.canViewSettings) {
                return null;
            }
            return (react_1.default.createElement("a", { href: _this.props.resultsUrl + "/settings", "aria-label": _this.props.i18n.t('left_navigation.settings.title') },
                react_1.default.createElement("i", { className: "acl-i-settings" }),
                react_1.default.createElement("span", { className: "results-panel__footer__text" }, _this.props.i18n.t('left_navigation.settings.title'))));
        };
        _this.renderFooter = function () {
            var archivedProjectslink = _this.renderArchivedProjectsLink();
            var activitiesLink = _this.renderActivitiesLink();
            var settingsLink = _this.renderSettingsLink();
            if (settingsLink || activitiesLink || archivedProjectslink) {
                return (react_1.default.createElement("div", { className: "results-panel__footer" },
                    archivedProjectslink,
                    activitiesLink,
                    settingsLink));
            }
        };
        _this.state = {
            dragging: false,
        };
        return _this;
    }
    ResizableLeftPanel.prototype.componentDidMount = function () {
        document.querySelector('body').addEventListener('mouseup', this.handleMouseUp, false);
        document.querySelector('body').addEventListener('mousemove', this.handleMouseMove, false);
    };
    ResizableLeftPanel.prototype.componentWillUnmount = function () {
        document.querySelector('body').removeEventListener('mouseup', this.handleMouseUp, false);
        document.querySelector('body').removeEventListener('mousemove', this.handleMouseUp, false);
    };
    ResizableLeftPanel.prototype.resizeHandler = function (width, backupWidth) {
        if (this.props.onResize) {
            this.props.onResize(width, backupWidth);
        }
    };
    ResizableLeftPanel.prototype.render = function () {
        this.props.i18n.t('left_navigation.collection_archive');
        var containerClass = classnames_1.default('results-panel', {
            'results-panel--collapsed': this.isCollapsed(),
            'results-panel--not-collapsed': !this.isCollapsed() && !this.state.dragging,
        });
        var iconClass = this.isCollapsed() ? 'acl-i-menu' : 'acl-i-times';
        var iconTooltipText = this.isCollapsed()
            ? this.props.i18n.t('left_navigation.sidenav_open')
            : this.props.i18n.t('left_navigation.sidenav_close');
        return (react_1.default.createElement("div", { style: { width: this.panelWidth() }, className: containerClass },
            react_1.default.createElement("div", { className: "results-panel__resize-bar", onMouseDown: this.handleMouseDown, onMouseUp: this.handleMouseUp, onMouseMove: this.handleMouseMove }),
            react_1.default.createElement("div", { className: "results-panel__contents" },
                react_1.default.createElement("span", { className: "results-panel__header" },
                    react_1.default.createElement(Tooltip_1.default, { align: "rightMiddle", message: iconTooltipText },
                        react_1.default.createElement("button", { className: "results-panel__toggle-button", "aria-label": iconTooltipText, onClick: this.collapseHandler },
                            react_1.default.createElement("i", { className: iconClass }))),
                    this.renderSearch()),
                react_1.default.createElement("div", { className: "results-panel__body" }, this.isCollapsed() ? null : this.props.children),
                this.renderFooter())));
    };
    ResizableLeftPanel.propTypes = {
        width: prop_types_1.default.number,
        backupWidth: prop_types_1.default.number,
        onResize: prop_types_1.default.func,
        children: prop_types_1.default.node,
        afterResizeCallback: prop_types_1.default.func,
        canViewSettings: prop_types_1.default.bool,
        onSearchChange: prop_types_1.default.func,
        collapseToggleCallback: prop_types_1.default.func,
        storyboardBaseUrl: prop_types_1.default.string,
        resultsUrl: prop_types_1.default.string,
        showSearchPopover: prop_types_1.default.bool,
        searchValue: prop_types_1.default.string,
        i18n: prop_types_1.default.object,
    };
    ResizableLeftPanel.defaultProps = {
        width: MIN_WIDTH,
        canViewSettings: false,
        storyboardBaseUrl: '',
        resultsUrl: '',
    };
    return ResizableLeftPanel;
}(react_1.default.Component));
// TODO refactor into a functional component to remove this workaround for using hooks
var withHooks = function (Component) {
    // eslint-disable-next-line
    return function (props) {
        var i18n = l10n_1.useI18n();
        return react_1.default.createElement(Component, __assign({ i18n: i18n }, props));
    };
};
exports.default = withHooks(ResizableLeftPanel);
//# sourceMappingURL=ResizableLeftPanel.js.map